function PersonalPresence(core) {
    this.client = core.client;
}

Object.assign(PersonalPresence.prototype, {
    namespace: 'PersonalPresence',
    put(baseUrl, params) {
        return this.client.send('PUT', baseUrl, params);
    }
});

export default PersonalPresence;
